import jsPDF from 'jspdf';
/* eslint-disable no-unused-vars */
import autoTable from 'jspdf-autotable';
import moment from 'moment';

export default {
  methods: {
    makePDF(includeNotes) {
      return new Promise((resolve, reject) => {
      let columns = ['', ''];
      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4',
        hotfixes: [], // an array of hotfix strings to enable
      });
      // let hseCase;
      // let hseTitle = '';
      let i = 0;
      let j = 0;

      // Initialise
      this.pageLeftMargin = 80;
      this.pageTopMargin = 50;
      this.pageLength = 700;
      this.fontName = 'Arial';
      this.fontStyle = 'light';

      this.titleFontSize = 20;
      this.titleFontStyle = 'normal';
      this.titleMarginTop = 0;
      this.titleMarginBottom = 8;

      this.sectionTitleFontSize = 16;
      this.sectionTitleFontStyle = 'normal';
      this.sectionTitleMarginTop = 0;
      this.sectionTitleMarginBottom = 8;

      this.subSectionTitleFontSize = 12;
      this.subSectionTitleFontStyle = 'normal';
      this.subSectionTitleMarginTop = 0;
      this.subSectionTitleMarginBottom = 10;
      this.subSectionMarginBottom = 24;

      this.defaultFontSize = 9;
      this.defaultFontStyle = 'normal';
      this.defaultMarginTop = 0;
      this.defaultMarginBottom = 10;

      this.tableTheme = 'grid';
      this.tableStyle = {
        font: this.fontName,
        fontSize: 9,
        textColor: 0,
        cellPadding: 3,
        overflow: 'linebreak',
      };
      this.tableHeaderStyle = {
        textColor: [0, 0, 0],
        fillColor: [226, 237, 255],
        lineWidth: 1,
        fontStyle: 'bold',
      };
      this.tableColumnStyle = [
        {
          fontStyle: 'bold',
          halign: 'left',
          columnWidth: 150,
          textColor: [0, 0, 0],
        },
        {
          columnWidth: 'auto',
          textColor: [60, 60, 60],
        },
      ];
      this.financialsTablesColumnStyles = [
        {
          fontStyle: 'bold',
          halign: 'left',
          columnWidth: '100',
          textColor: [0, 0, 0],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
        {
          columnWidth: 'wrap',
          halign: 'right',
          textColor: [60, 60, 60],
        },
      ];

      this.setPageStart(this.pageLeftMargin, this.pageTopMargin - 20);
      doc.addFont(this.fontName, this.fontName, this.fontStyle);
      doc.setFont(this.fontName);
      doc.setTextColor(0, 0, 0);
      // package up data
      const { companyoverview } = this.reportData;

      // Report header
      doc.setFontSize(10);
      this.setTextDimensions(doc.getTextDimensions('Text'));

      // Todo: partner logo goes here
      // doc.rect(this.cursorX, this.cursorY, 200, this.pageTopMargin - 10)
      doc.text(
        `Report Date: ${this.formatDate(companyoverview.created_at)}`,
        440,
        this.pageTopMargin - 30
      );
      this.moveCursorYRelative(20);

      // company Name
      doc.setFontSize(20);
      doc.setFontStyle(this.titleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      this.moveCursorYRelative(this.titleMarginTop);
      doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
      this.newLine(this.titleMarginBottom);

      // Overview
      this.moveCursorYRelative(this.sectionTitleMarginTop);
      doc.setFontSize(this.sectionTitleFontSize);
      doc.setFontStyle(this.sectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Overview', this.cursorX, this.cursorY);
      this.newLine(this.sectionTitleMarginBottom);

      // Company Details
      this.moveCursorYRelative(this.subSectionTitleMarginTop);
      doc.setFontSize(this.subSectionTitleFontSize);
      doc.setFontStyle(this.subSectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Company Details', this.cursorX, this.cursorY);
      this.moveCursorYRelative(this.subSectionTitleMarginBottom);

      // Panel Body
      let res = doc.autoTableHtmlToJson(document.getElementById('company-details-table', false));
      doc.autoTable(res.columns, res.data, {
        margin: {
          left: this.pageStartX,
        },
        startY: this.cursorY,
        showHeader: 'everyPage',

        theme: this.tableTheme,
        styles: this.tableStyle,
        headerStyles: this.tableHeaderStyle,
        columnStyles: this.tableColumnStyle,
      });

      this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

      // Contact Details
      this.moveCursorYRelative(this.subSectionTitleMarginTop);
      doc.setFontSize(this.subSectionTitleFontSize);
      doc.setFontStyle(this.subSectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Contact Details', this.cursorX, this.cursorY);
      this.moveCursorYRelative(this.subSectionTitleMarginBottom);

      res = doc.autoTableHtmlToJson(document.getElementById('contact-details-table'));
      doc.autoTable(res.columns, res.data, {
        margin: {
          left: this.pageStartX,
        },
        startY: this.cursorY,
        showHeader: 'everyPage',

        theme: this.tableTheme,
        styles: this.tableStyle,
        headerStyles: this.tableHeaderStyle,
        columnStyles: this.tableColumnStyle,
      });

      this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

      if (companyoverview.financials.length > 0) {
        // Key financials
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Key Financials', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        res = doc.autoTableHtmlToJson(document.getElementById('key-financials-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;
      }

      // Descriptions
      this.moveCursorYRelative(this.subSectionTitleMarginTop);
      doc.setFontSize(this.subSectionTitleFontSize);
      doc.setFontStyle(this.subSectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Company Description', this.cursorX, this.cursorY);
      this.moveCursorYRelative(this.subSectionTitleMarginBottom);

      // Sic codes
      columns = ['Type', 'Code', 'Description'];
      let rows = [];
      let newSic = [];
      for (i = 0; i < companyoverview.sic_code2007s.length; i += 1) {
        newSic = [
          '2007 SIC:',
          companyoverview.sic_code2007s[i].code,
          companyoverview.sic_code2007s[i].name,
        ];
        rows.push(newSic);
      }

      for (i = 0; i < companyoverview.sic_code2003s.length; i += 1) {
        newSic = [
          '2003 SIC:',
          companyoverview.sic_code2003s[i].code,
          companyoverview.sic_code2003s[i].name,
        ];
        rows.push(newSic);
      }

      doc.autoTable(columns, rows, {
        margin: {
          left: this.pageStartX,
        },
        startY: this.cursorY,
        showHeader: 'everyPage',

        theme: this.tableTheme,
        styles: this.tableStyle,
        headerStyles: this.tableHeaderStyle,
        columnStyles: [
          {
            fontStyle: 'bold',
            halign: 'left',
            columnWidth: 150,
            textColor: [0, 0, 0],
          },
          {
            columnWidth: 40,
            textColor: [0, 0, 0],
          },
          {
            columnWidth: 'auto',
            textColor: [0, 0, 0],
          },
        ],
      });
      this.cursorY = doc.autoTable.previous.finalY + 10;

      // Keywords
      columns = ['Keywords (Ordered by relevance)'];
      rows = [];
      let keywords = '';
      for (i = 0; i < companyoverview.keywords.length; i += 1) {
        keywords = `${keywords + companyoverview.keywords[i].keyword}, `;
      }
      rows.push([keywords]);

      doc.autoTable(columns, rows, {
        margin: {
          left: this.pageStartX,
        },
        startY: this.cursorY,
        showHeader: 'everyPage',

        theme: this.tableTheme,
        styles: this.tableStyle,
        headerStyles: this.tableHeaderStyle,
        columnStyles: [
          {
            fontStyle: 'normal',
            halign: 'left',
            columnWidth: 'auto',
            textColor: [0, 0, 0],
          },
        ],
      });

      this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;
      /// ////////////////////////////////////////////////
      // NEW PAGE _ Company information
      /// ////////////////////////////////////////////////
      doc.addPage();
      this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
      // page header
      doc.setTextColor(150, 150, 150);
      // company Name
      doc.setFontSize(20);
      doc.setFontStyle('normal');
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
      // report date
      doc.setFontSize(10);
      doc.setFontStyle('normal');
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text(
        `Report Date: ${this.formatDate(companyoverview.created_at)}`,
        440,
        this.pageTopMargin - 30
      );
      this.moveCursorYRelative(40);

      doc.setTextColor(0, 0, 0);

      // COMPANY INFORMATION
      this.moveCursorYRelative(this.sectionTitleMarginTop);
      doc.setFontSize(this.sectionTitleFontSize);
      doc.setFontStyle(this.sectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Company Information', this.cursorX, this.cursorY);
      this.newLine(this.sectionTitleMarginBottom);

      // Company Descriptions
      if (companyoverview.descriptions.length > 0) {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Descriptions', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        if (this.reportData.is_creditsafe_report) {
          columns = ['Description'];
        } else {
          columns = ['Source', 'Description'];
        }

        rows = [];

        for (i = 0; i < companyoverview.descriptions.length; i += 1) {
          const description = companyoverview.descriptions[i];

          if (this.reportData.is_creditsafe_report) {
            rows.push([description.text]);
          } else {
            rows.push([description.source, description.text]);
          }
        }

        let columnStyles = this.tableColumnStyle;
        if (this.reportData.is_creditsafe_report) {
          columnStyles = [
            {
              fontStyle: 'normal',
              halign: 'left',
              columnWidth: 'auto',
              textColor: [0, 0, 0],
            },
          ];
        }
        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles,
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      // HSE cases
      // if (this.reportData.includes_hse && companyoverview.hsecases.length > 0) {
      //   hseTitle = 'Cases';
      //   this.moveCursorYRelative(this.subSectionTitleMarginTop);
      //   doc.setFontSize(this.subSectionTitleFontSize);
      //   doc.setFontStyle(this.subSectionTitleFontStyle);
      //   this.setTextDimensions(doc.getTextDimensions('Text'));
      //   if (companyoverview.hsecases.length === 1) {
      //     hseTitle = 'Case';
      //   }
      //   doc.text(
      //     `HSE Cases (${companyoverview.hsecases.length} ${hseTitle})`,
      //     this.cursorX,
      //     this.cursorY,
      //   );
      //   this.moveCursorYRelative(this.subSectionTitleMarginBottom);
      //
      //   columns = ['Detail', 'Value'];
      //   rows = [];
      //
      //   for (i = 0; i < companyoverview.hsecases.length; i += 1) {
      //     hseCase = companyoverview.hsecases[i];
      //
      //     rows.push(['HSE Case Number', this.isEmptyMessage(hseCase.case_number)]);
      //     rows.push(["Defendant's Name", this.isEmptyMessage(hseCase.defendants_name)]);
      //     rows.push(['Offence Date', this.isEmptyMessage(hseCase.offence_date)]);
      //     rows.push(['Local Authority', this.isEmptyMessage(hseCase.local_authority)]);
      //     rows.push(['Main Activity', this.isEmptyMessage(hseCase.main_activity)]);
      //   }
      //
      //   doc.autoTable(columns, rows, {
      //     margin: {
      //       left: this.pageStartX,
      //     },
      //     startY: this.cursorY,
      //     showHeader: 'everyPage',
      //
      //     theme: this.tableTheme,
      //     styles: this.tableStyle,
      //     headerStyles: this.tableHeaderStyle,
      //     columnStyles: this.tableColumnStyle,
      //   });
      //
      //   this.cursorY = doc.autoTable.previous.finalY + 20;
      // }

      // Web and Social Media
      if (companyoverview.webpresences.length > 0) {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Online Presence', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        columns = ['Type', 'Profile Name', 'Url'];
        rows = [];

        for (i = 0; i < companyoverview.webpresences.length; i += 1) {
          const webpresence = companyoverview.webpresences[i];

          rows.push([
            webpresence.presencetype.name,
            this.isEmptyMessage(webpresence.profile_name),
            webpresence.url,
          ]);
        }

        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      // Previous Names
      if (companyoverview.registerednames.length > 0) {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Previous Names', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('previous-names-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      // Shareholders
      if (companyoverview.shareholders.length > 0) {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Shareholding', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('shareholders-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      // Parent Companies
      if (companyoverview.groupparents.length > 0) {
        if (companyoverview.groupparents.length * this.textHeight + 2 > this.pageLength - 200) {
          // Subsidiary page content is large so make a new page
          doc.addPage();
          this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
          // page header
          doc.setTextColor(150, 150, 150);
          // company Name
          doc.setFontSize(20);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
          // report date
          doc.setFontSize(10);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(
            `Report Date: ${this.formatDate(companyoverview.created_at)}`,
            440,
            this.pageTopMargin - 30
          );
          this.moveCursorYRelative(40);

          doc.setTextColor(0, 0, 0);

          this.moveCursorYRelative(this.sectionTitleMarginTop);
          doc.setFontSize(this.sectionTitleFontSize);
          doc.setFontStyle(this.sectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('Company Information', this.cursorX, this.cursorY);
          this.newLine(this.sectionTitleMarginBottom);
        }

        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Parent Companies', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        columns = ['Country', 'Compa1ny', 'Relationship'];
        rows = [];

        for (i = 0; i < companyoverview.groupparents.length; i += 1) {
          let relationship = '';
          let countryCode = '';

          const parent = companyoverview.groupparents[i];

          if (parent.is_ultimate_parent) {
            relationship += 'Ultimate Parent  ';
          } else if (parent.is_immediate_parent) {
            relationship += 'Immediate Parent';
          }

          if (parent.country !== null && parent.country !== undefined) {
            countryCode = parent.country.code.toUpperCase();
          }
          rows.push([countryCode, parent.name, relationship]);
        }

        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      // Subsidiary Companies
      if (companyoverview.groupsubsidiaries.length > 0) {
        if (
          companyoverview.groupsubsidiaries.length * this.textHeight + 2 >
          this.pageLength - 200
        ) {
          // Subsidiary page content is large so make a new page
          doc.addPage();
          this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
          // page header
          doc.setTextColor(150, 150, 150);
          // company Name
          doc.setFontSize(20);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
          // report date
          doc.setFontSize(10);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(
            `Report Date: ${this.formatDate(companyoverview.created_at)}`,
            440,
            this.pageTopMargin - 30
          );
          this.moveCursorYRelative(40);

          doc.setTextColor(0, 0, 0);

          this.moveCursorYRelative(this.sectionTitleMarginTop);
          doc.setFontSize(this.sectionTitleFontSize);
          doc.setFontStyle(this.sectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('Company Information', this.cursorX, this.cursorY);
          this.newLine(this.sectionTitleMarginBottom);
        }

        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Subsidiary Companies', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        columns = ['Country', 'Company'];
        rows = [];

        for (i = 0; i < companyoverview.groupsubsidiaries.length; i += 1) {
          const subsidiary = companyoverview.groupsubsidiaries[i];

          rows.push([subsidiary.country.code.toUpperCase(), subsidiary.name]);
        }

        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      /// ////////////////////////////////////////////////
      // New Page - FINANCES
      /// ////////////////////////////////////////////////
      doc.addPage();
      this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
      // page header
      doc.setTextColor(150, 150, 150);
      // company Name
      doc.setFontSize(20);
      doc.setFontStyle('normal');
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
      // report date
      doc.setFontSize(10);
      doc.setFontStyle('normal');
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text(
        `Report Date: ${this.formatDate(companyoverview.created_at)}`,
        440,
        this.pageTopMargin - 30
      );
      this.moveCursorYRelative(40);

      doc.setTextColor(0, 0, 0);

      this.moveCursorYRelative(this.sectionTitleMarginTop);
      doc.setFontSize(this.sectionTitleFontSize);
      doc.setFontStyle(this.sectionTitleFontStyle);
      this.setTextDimensions(doc.getTextDimensions('Text'));
      doc.text('Finances', this.cursorX, this.cursorY);
      this.newLine(this.sectionTitleMarginBottom);

      if (companyoverview.financials.length === 0) {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('No financial data available.', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);
      } else {
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Financial Reporting', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('financial-reporting-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;

        // Key Financials
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Key Financials', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('key-financials-detail-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.financialsTablesColumnStyles,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;

        // Profit & Loss
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Profit & Loss', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('profit-loss-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.financialsTablesColumnStyles,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;

        // Key ratios
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Key Ratios', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('key-ratios-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.financialsTablesColumnStyles,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;

        /// ////////////////////////////////////////////////
        // New Page - FINANCES Continued
        /// ////////////////////////////////////////////////
        doc.addPage();
        this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
        // page header
        doc.setTextColor(150, 150, 150);
        // company Name
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
        // report date
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(
          `Report Date: ${this.formatDate(companyoverview.created_at)}`,
          440,
          this.pageTopMargin - 30
        );
        this.moveCursorYRelative(40);

        doc.setTextColor(150, 150, 150);

        this.moveCursorYRelative(this.sectionTitleMarginTop);
        doc.setFontSize(this.sectionTitleFontSize);
        doc.setFontStyle(this.sectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Finances - Continued', this.cursorX, this.cursorY);
        this.newLine(this.sectionTitleMarginBottom);

        doc.setTextColor(0, 0, 0);

        // Balance Sheet
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Balance Sheet', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        // Panel Body
        columns = ['', ''];
        res = doc.autoTableHtmlToJson(document.getElementById('balance-sheet-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'firstPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.financialsTablesColumnStyles,
          createdCell(cell) {
            const lCell = cell;
            const zero = 0;
            lCell.text = cell.text[zero];
          },
          drawHeaderRow() {},
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;
      }

      /// ////////////////////////////////////////////////
      // NEW PAGE _ one per director
      /// ////////////////////////////////////////////////
      let officer = [];
      for (i = 0; i < companyoverview.officers.length; i += 1) {
        officer = companyoverview.officers[i];
        if (officer.current_status === 'open') {
          doc.addPage();
          this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
          // page header
          doc.setTextColor(150, 150, 150);
          // company Name
          doc.setFontSize(20);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
          // report date
          doc.setFontSize(10);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(
            `Report Date: ${this.formatDate(companyoverview.created_at)}`,
            440,
            this.pageTopMargin - 30
          );
          this.moveCursorYRelative(40);
          doc.setTextColor(0, 0, 0);

          if (officer.officertype.name === 'person') {
            // Section Heading
            this.moveCursorYRelative(this.sectionTitleMarginTop);
            doc.setFontSize(this.sectionTitleFontSize);
            doc.setFontStyle(this.sectionTitleFontStyle);
            this.setTextDimensions(doc.getTextDimensions('Text'));
            if (
              officer.full_name !== null &&
              officer.full_name !== undefined &&
              officer.full_name.length > 0
            ) {
              doc.text(officer.full_name, this.cursorX, this.cursorY);
            } else {
              doc.text('', this.cursorX, this.cursorY);
            }
            this.newLine();
            // position
            if (officer.current_position !== null) {
              this.moveCursorYRelative(this.subSectionTitleMarginTop);
              doc.setFontSize(this.subSectionTitleFontSize);
              doc.setFontStyle(this.subSectionTitleFontStyle);
              this.setTextDimensions(doc.getTextDimensions('Text'));
              doc.text(officer.current_position, this.cursorX, this.cursorY);
              this.moveCursorYRelative(this.subSectionTitleMarginBottom + 5);
            }
            // DOB
            if (officer.date_of_birth_year !== null) {
              doc.setFontSize(this.defaultFontSize);
              doc.setFontStyle(this.defaultFontStyle);
              this.setTextDimensions(doc.getTextDimensions('Text'));
              doc.text(
                `Born: ${this.isEmptyMessage(
                  this.formatDOB(officer.date_of_birth_month, officer.date_of_birth_year)
                )}`,
                this.cursorX,
                this.cursorY
              );
              this.moveCursorYRelative(20);
            }
          } else {
            // Company name
            this.moveCursorYRelative(this.sectionTitleMarginTop);
            doc.setFontSize(this.sectionTitleFontSize);
            doc.setFontStyle(this.sectionTitleFontStyle);
            this.setTextDimensions(doc.getTextDimensions('Text'));
            doc.text(officer.company_name, this.cursorX, this.cursorY);
            this.newLine();
            // position
            if (officer.current_position !== null) {
              this.moveCursorYRelative(this.subSectionTitleMarginTop);
              doc.setFontSize(this.subSectionTitleFontSize);
              doc.setFontStyle(this.subSectionTitleFontStyle);
              this.setTextDimensions(doc.getTextDimensions('Text'));
              doc.text(officer.current_position, this.cursorX, this.cursorY);
              this.moveCursorYRelative(this.subSectionTitleMarginBottom + 5);
            }
            // Company reg number
            if (officer.company_registration_number !== 'undefined') {
              doc.setFontSize(this.defaultFontSize);
              doc.setFontStyle(this.defaultFontStyle);
              this.setTextDimensions(doc.getTextDimensions('Text'));
              doc.text(
                `Registration Number: ${this.isEmptyMessage(officer.company_registration_number)}`,
                this.cursorX,
                this.cursorY
              );
              this.moveCursorYRelative(20);
            }
          }

          this.moveCursorYRelative(10);

          // Company Directorships
          this.moveCursorYRelative(this.subSectionTitleMarginTop);
          doc.setFontSize(this.subSectionTitleFontSize);
          doc.setFontStyle(this.subSectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          if (!this.reportData.includes_director_reports) {
            // doc.text('', this.cursorX, this.cursorY);
          } else {
            doc.text('Company Directorships', this.cursorX, this.cursorY);
          }
          this.moveCursorYRelative(this.subSectionTitleMarginBottom);

          columns = ['Detail', 'Value'];
          let companyappointment = [];
          for (j = 0; j < officer.appointments.length; j += 1) {
            rows = [];
            companyappointment = officer.appointments[j];

            if (companyappointment.status !== 'retired') {
              rows.push(
                ['Company:', this.isEmptyMessage(companyoverview.company_name)],
                ['Function:', this.isEmptyMessage(companyappointment.official_role)],
                ['Position:', this.isEmptyMessage(companyappointment.position)],
                ['Status:', this.isEmptyMessage(companyappointment.status)],
                ['Appointment date:', this.formatDate(companyappointment.start_date)]
              );

              doc.autoTable(columns, rows, {
                margin: {
                  left: this.pageStartX,
                },
                startY: this.cursorY,
                showHeader: 'everyPage',

                theme: this.tableTheme,
                styles: this.tableStyle,
                headerStyles: this.tableHeaderStyle,
                columnStyles: this.tableColumnStyle,
              });

              this.cursorY = doc.autoTable.previous.finalY + 10;
            }
          }

          this.moveCursorYRelative(20);

          if (officer.otherappointments.length > 0) {
            // Other Directorships
            this.moveCursorYRelative(this.subSectionTitleMarginTop);
            doc.setFontSize(this.subSectionTitleFontSize);
            doc.setFontStyle(this.subSectionTitleFontStyle);
            this.setTextDimensions(doc.getTextDimensions('Text'));
            doc.text('Other Directorships', this.cursorX, this.cursorY);
            this.moveCursorYRelative(this.subSectionTitleMarginBottom);

            columns = ['Detail', 'Value'];
            let otherappointment = [];
            for (j = 0; j < officer.otherappointments.length; j += 1) {
              // if we're near the bottom of the page make a new one
              if (this.cursorY > this.pageLength) {
                /// //////////////////////////
                // New page
                /// /////////////////////////
                doc.addPage();
                this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
                // page header
                doc.setTextColor(150, 150, 150);
                // company Name
                doc.setFontSize(20);
                doc.setFontStyle('normal');
                this.setTextDimensions(doc.getTextDimensions('Text'));
                doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
                // report date
                doc.setFontSize(10);
                doc.setFontStyle('normal');
                this.setTextDimensions(doc.getTextDimensions('Text'));
                doc.text(
                  `Report Date: ${this.formatDate(companyoverview.created_at)}`,
                  440,
                  this.pageTopMargin - 30
                );
                this.moveCursorYRelative(40);

                if (officer.officertype.name === 'person') {
                  // Section Heading
                  this.moveCursorYRelative(this.sectionTitleMarginTop);
                  doc.setFontSize(this.sectionTitleFontSize);
                  doc.setFontStyle(this.sectionTitleFontStyle);
                  this.setTextDimensions(doc.getTextDimensions('Text'));
                  doc.text(officer.full_name, this.cursorX, this.cursorY);
                  this.newLine();
                } else {
                  // Company name
                  this.moveCursorYRelative(this.sectionTitleMarginTop);
                  doc.setFontSize(this.sectionTitleFontSize);
                  doc.setFontStyle(this.sectionTitleFontStyle);
                  this.setTextDimensions(doc.getTextDimensions('Text'));
                  doc.text(officer.company_name, this.cursorX, this.cursorY);
                  this.newLine();
                }

                this.moveCursorYRelative(this.subSectionTitleMarginTop);
                doc.setFontSize(this.subSectionTitleFontSize);
                doc.setFontStyle(this.subSectionTitleFontStyle);
                this.setTextDimensions(doc.getTextDimensions('Text'));
                doc.text('Other Directorships - continued', this.cursorX, this.cursorY);
                this.moveCursorYRelative(this.subSectionTitleMarginBottom);
                doc.setTextColor(0, 0, 0);
              }
              rows = [];
              otherappointment = officer.otherappointments[j];

              if (otherappointment.status !== 'retired') {
                rows.push(
                  ['Company:', this.isEmptyMessage(otherappointment.company_name)],
                  ['Country:', otherappointment.country.code.toUpperCase()],
                  ['Function:', this.isEmptyMessage(otherappointment.official_role)],
                  ['Position:', this.isEmptyMessage(otherappointment.position)],
                  ['Status:', this.isEmptyMessage(otherappointment.status)],
                  [
                    'Appointment date:',
                    this.isEmptyMessage(this.formatDate(otherappointment.start_date)),
                  ]
                );

                doc.autoTable(columns, rows, {
                  margin: {
                    left: this.pageStartX,
                  },
                  startY: this.cursorY,
                  showHeader: 'everyPage',

                  theme: this.tableTheme,
                  styles: this.tableStyle,
                  headerStyles: this.tableHeaderStyle,
                  columnStyles: this.tableColumnStyle,
                });

                this.cursorY = doc.autoTable.previous.finalY + 20;

                // HSE cases on other directorship
                if (this.reportData.includes_hse && otherappointment.hsecases.length > 0) {
                  hseTitle = 'Cases';
                  this.moveCursorYRelative(this.subSectionTitleMarginTop);
                  doc.setFontSize(this.subSectionTitleFontSize);
                  doc.setFontStyle(this.subSectionTitleFontStyle);
                  this.setTextDimensions(doc.getTextDimensions('Text'));
                  if (otherappointment.hsecases.length === 1) {
                    hseTitle = 'Case';
                  }
                  doc.text(`HSE ${hseTitle}`, this.cursorX + 20, this.cursorY);
                  this.moveCursorYRelative(this.subSectionTitleMarginBottom);

                  columns = ['Detail', 'Value'];
                  rows = [];

                  for (i = 0; i < otherappointment.hsecases.length; i += 1) {
                    hseCase = otherappointment.hsecases[i];

                    rows.push(['HSE Case Number', this.isEmptyMessage(hseCase.case_number)]);
                    rows.push(["Defendant's Name", this.isEmptyMessage(hseCase.defendants_name)]);
                    rows.push(['Offence Date', this.isEmptyMessage(hseCase.offence_date)]);
                    rows.push(['Local Authority', this.isEmptyMessage(hseCase.local_authority)]);
                    rows.push(['Main Activity', this.isEmptyMessage(hseCase.main_activity)]);
                  }

                  doc.autoTable(columns, rows, {
                    margin: {
                      left: this.pageStartX + 20,
                    },
                    startY: this.cursorY,
                    showHeader: 'everyPage',

                    theme: this.tableTheme,
                    styles: this.tableStyle,
                    headerStyles: this.tableHeaderStyle,
                    columnStyles: this.tableColumnStyle,
                  });

                  this.cursorY = doc.autoTable.previous.finalY + 30;
                }
              }
            }
          }

          //           } else {
          //           // Section Heading
          //           this.moveCursorYRelative(this.sectionTitleMarginTop)
          //           doc.setFontSize(this.sectionTitleFontSize)
          //           doc.setFontStyle(this.sectionTitleFontStyle)
          //           this.setTextDimensions(doc.getTextDimensions('Text'))
          //           doc.text(officer.company_name, this.cursorX, this.cursorY)
          //           this.newLine()
        }
      }

      /// ///////////////////////////////////////////////
      // New Page - Locations
      /// ////////////////////////////////////////////////

      for (j = 0; j < companyoverview.locations.length; j += 1) {
        doc.addPage();
        this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
        // page header
        doc.setTextColor(150, 150, 150);
        // company Name
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
        // report date
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(
          `Report Date: ${this.formatDate(companyoverview.created_at)}`,
          440,
          this.pageTopMargin - 30
        );
        this.moveCursorYRelative(40);

        doc.setTextColor(0, 0, 0);

        this.moveCursorYRelative(this.sectionTitleMarginTop);
        doc.setFontSize(this.sectionTitleFontSize);
        doc.setFontStyle(this.sectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Location', this.cursorX, this.cursorY);
        this.newLine(this.sectionTitleMarginBottom);

        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        if (companyoverview.locations[j].label != null) {
          doc.text(companyoverview.locations[j].label, this.cursorX, this.cursorY);
        } else {
          doc.text('Registered Address', this.cursorX, this.cursorY);
        }

        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        columns = [];
        // Location details
        if (companyoverview.locations[j].full !== '') {
          columns = ['Address', companyoverview.locations[j].full];
        } else {
          columns = ['Postcode', companyoverview.locations[j].postcode];
        }
        rows = [];

        if (companyoverview.locations[j].postcode == null) {
          rows.push(['Link to map:', 'No map available for address details.']);
        } else {
          rows.push([
            'Link to map:',
            `https://maps.google.com/maps?q=${companyoverview.locations[j].postcode.replace(
              /\s/g,
              ''
            )}`,
          ]);
        }

        if (companyoverview.locations[j].risk == null) {
          rows.push(['Underwriting Guide', 'No data available for this location.']);
          rows.push(['Fire Response Times', 'No data available for this location.']);
        }

        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + 20;

        if (companyoverview.locations[j].risk != null) {
          this.moveCursorYRelative(this.subSectionTitleMarginTop);
          doc.setFontSize(this.subSectionTitleFontSize);
          doc.setFontStyle(this.subSectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('Underwriting Guide', this.cursorX, this.cursorY);
          this.moveCursorYRelative(this.subSectionTitleMarginBottom);

          // Underwriting details
          columns = ['Category', 'Status', 'Commentary'];
          rows = [];
          rows.push([
            'Theft:',
            companyoverview.locations[j].risk.theft_rag,
            this.getUnderwritingComment('theft', companyoverview.locations[j].risk.theft_rag),
          ]);
          rows.push([
            'Subsidence:',
            companyoverview.locations[j].risk.subsidence_rag,
            this.getUnderwritingComment(
              'subsidence',
              companyoverview.locations[j].risk.subsidence_rag
            ),
          ]);
          rows.push([
            'Flood:',
            companyoverview.locations[j].risk.flood_rag,
            this.getUnderwritingComment('flood', companyoverview.locations[j].risk.flood_rag),
          ]);
          rows.push([
            'Terrorism:',
            '',
            `Pool Re zone: ${companyoverview.locations[j].risk.terrorism_rating}`,
          ]);

          doc.autoTable(columns, rows, {
            margin: {
              left: this.pageStartX,
            },
            startY: this.cursorY,
            showHeader: 'everyPage',

            theme: this.tableTheme,
            styles: this.tableStyle,
            headerStyles: this.tableHeaderStyle,
            columnStyles: [
              {
                fontStyle: 'bold',
                halign: 'left',
                columnWidth: 150,
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 40,
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
              },
            ],
          });

          this.cursorY = doc.autoTable.previous.finalY + 20;

          this.moveCursorYRelative(this.subSectionTitleMarginTop);
          doc.setFontSize(this.subSectionTitleFontSize);
          doc.setFontStyle(this.subSectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('Fire Response Times', this.cursorX, this.cursorY);
          this.moveCursorYRelative(this.subSectionTitleMarginBottom);

          // Underwriting details
          columns = ['', 'High-volume pumping unit', 'Aerial ladder platform'];
          rows = [];
          rows.push([
            '9 - 5',
            `${companyoverview.locations[j].risk.fire_9to5_hvp_rag}: ${this.isEmptyMessage(
              this.SecondsTohhmmss(companyoverview.locations[j].risk.fire_9to5_hvp_response)
            )}`,
            `${companyoverview.locations[j].risk.fire_9to5_aerial_rag}: ${this.isEmptyMessage(
              this.SecondsTohhmmss(companyoverview.locations[j].risk.fire_9to5_aerial_response)
            )}`,
          ]);

          rows.push([
            '8 - 6',
            `${companyoverview.locations[j].risk.fire_8to6_hvp_rag}: ${this.isEmptyMessage(
              this.SecondsTohhmmss(companyoverview.locations[j].risk.fire_8to6_hvp_response)
            )}`,
            `${companyoverview.locations[j].risk.fire_9to6_aerial_rag}: ${this.isEmptyMessage(
              this.SecondsTohhmmss(companyoverview.locations[j].risk.fire_8to6_aerial_response)
            )}`,
          ]);

          doc.autoTable(columns, rows, {
            margin: {
              left: this.pageStartX,
            },
            startY: this.cursorY,
            showHeader: 'everyPage',

            theme: this.tableTheme,
            styles: this.tableStyle,
            headerStyles: this.tableHeaderStyle,
            columnStyles: [
              {
                fontStyle: 'bold',
                halign: 'left',
                columnWidth: 150,
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
              },
            ],
          });

          this.moveCursorYRelative(80);
        }
      }

      // Only include credit section if we have data
      if (companyoverview.creditreport != null && companyoverview.creditreport.length !== 0) {
        /// ////////////////////////////////////////////////
        // NEW PAGE - Credit information
        /// ////////////////////////////////////////////////
        doc.addPage();
        this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
        // page header
        doc.setTextColor(150, 150, 150);
        // company Name
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
        // report date
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(
          `Report Date: ${this.formatDate(companyoverview.created_at)}`,
          440,
          this.pageTopMargin - 30
        );
        this.moveCursorYRelative(40);

        doc.setTextColor(0, 0, 0);

        // Credit Details
        // Section Heading
        this.moveCursorYRelative(this.sectionTitleMarginTop);
        doc.setFontSize(this.sectionTitleFontSize);
        doc.setFontStyle(this.sectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Credit Information', this.cursorX, this.cursorY);
        this.newLine(this.sectionTitleMarginBottom);

        // Credit Scores
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Credit Score', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        res = doc.autoTableHtmlToJson(document.getElementById('credit-score-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: {
            textColor: [0, 0, 0],
            fillColor: [226, 237, 255],
            lineWidth: 1,
            fontStyle: 'bold',
          },
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

        // Credit Scores
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Credit History', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        res = doc.autoTableHtmlToJson(document.getElementById('credit-history-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: {
            textColor: [0, 0, 0],
            fillColor: [226, 237, 255],
            lineWidth: 1,
            fontStyle: 'bold',
          },
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

        // Credit Commentary
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Credit Commentary', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        res = doc.autoTableHtmlToJson(document.getElementById('credit-commentary-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: {
            textColor: [0, 0, 0],
            fillColor: [226, 237, 255],
            lineWidth: 1,
            fontStyle: 'bold',
          },
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

        // Credit Limits
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Credit Limits', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        res = doc.autoTableHtmlToJson(document.getElementById('credit-limits-table'));
        doc.autoTable(res.columns, res.data, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'everyPage',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: {
            textColor: [0, 0, 0],
            fillColor: [226, 237, 255],
            lineWidth: 1,
            fontStyle: 'bold',
          },
          columnStyles: this.tableColumnStyle,
        });

        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;

        columns = [''];
        rows = [];
        let cellBackgroundColor = [];

        // County Court Judgements
        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(this.subSectionTitleFontSize);
        doc.setFontStyle(this.subSectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('County Court Judgements', this.cursorX, this.cursorY);
        this.moveCursorYRelative(this.subSectionTitleMarginBottom);

        if (companyoverview.creditreport.countycourtjudgments.length === 0) {
          rows.push([
            `NO County Court Judgements found using the search term: ${companyoverview.company_name}`,
          ]);
          cellBackgroundColor = [214, 249, 199];
        } else {
          rows.push([
            `Possible County Court Judgements found, using the search term: ${companyoverview.company_name}. Where [possible] matches are indicated please check the address details below to ensure any CCJs listed match those of ${companyoverview.company_name}.`,
          ]);
          cellBackgroundColor = [249, 199, 199];
        }
        doc.autoTable(columns, rows, {
          margin: {
            left: this.pageStartX,
          },
          startY: this.cursorY,
          showHeader: 'never',

          theme: this.tableTheme,
          styles: this.tableStyle,
          headerStyles: this.tableHeaderStyle,
          columnStyles: [
            {
              fontStyle: 'normal',
              halign: 'center',
              columnWidth: 'auto',
              textColor: [0, 0, 0],
              cellPadding: 15,
              fillColor: cellBackgroundColor,
            },
          ],
        });
        this.cursorY = doc.autoTable.previous.finalY + 10;

        if (companyoverview.creditreport.countycourtjudgments.length !== 0) {
          /// ////////////////////////////////////////////////
          // NEW PAGE
          // Because the ccj list can be quite long!
          /// ////////////////////////////////////////////////
          doc.addPage();
          this.setPageStart(this.pageLeftMargin, this.pageTopMargin);

          // page header
          doc.setTextColor(150, 150, 150);
          // company Name

          // company Name
          doc.setFontSize(20);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
          // report date
          doc.setFontSize(10);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(
            `Report Date: ${this.formatDate(companyoverview.created_at)}`,
            440,
            this.pageTopMargin - 30
          );
          this.moveCursorYRelative(40);

          doc.setTextColor(0, 0, 0);

          // Section Heading
          this.moveCursorYRelative(this.sectionTitleMarginTop);
          doc.setFontSize(this.sectionTitleFontSize);
          doc.setFontStyle(this.sectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('Credit Information', this.cursorX, this.cursorY);
          this.newLine(this.sectionTitleMarginBottom);

          // County Court Judgements
          this.moveCursorYRelative(this.subSectionTitleMarginTop);
          doc.setFontSize(this.subSectionTitleFontSize);
          doc.setFontStyle(this.subSectionTitleFontStyle);
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text('County Court Judgements - Details', this.cursorX, this.cursorY);
          this.moveCursorYRelative(this.subSectionTitleMarginBottom);

          this.moveCursorYRelative(this.subSectionTitleMarginBottom);

          res = doc.autoTableHtmlToJson(document.getElementById('credit-ccj-detail-table'));
          doc.autoTable(res.columns, res.data, {
            margin: {
              left: this.pageStartX,
            },
            startY: this.cursorY,
            showHeader: 'everyPage',

            theme: this.tableTheme,
            styles: this.tableStyle,
            headerStyles: {
              textColor: [0, 0, 0],
              fillColor: [226, 237, 255],
              lineWidth: 1,
              fontStyle: 'bold',
            },
            columnStyles: [
              {
                fontStyle: 'bold',
                halign: 'left',
                columnWidth: 60,
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
                overflow: 'linebreak',
              },
              {
                columnWidth: 50,
                textColor: [0, 0, 0],
              },
              {
                columnWidth: 'auto',
                textColor: [0, 0, 0],
              },
            ],
          });
        }
        this.cursorY = doc.autoTable.previous.finalY + this.subSectionMarginBottom;
      }

      if (this.reportData.includes_sanctions && companyoverview.sanctions.length > 0) {
        /// ////////////////////////////////////////////////
        // NEW PAGE - Sanctions
        /// ////////////////////////////////////////////////
        doc.addPage();
        this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
        // page header
        doc.setTextColor(150, 150, 150);
        // company Name
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
        // report date
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(
          `Report Date: ${this.formatDate(companyoverview.created_at)}`,
          440,
          this.pageTopMargin - 30
        );
        this.moveCursorYRelative(40);

        doc.setTextColor(0, 0, 0);

        // Sanctions
        // Section Heading
        this.moveCursorYRelative(this.sectionTitleMarginTop);
        doc.setFontSize(this.sectionTitleFontSize);
        doc.setFontStyle(this.sectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Potential sanctions matches', this.cursorX, this.cursorY);
        this.newLine(this.sectionTitleMarginBottom);

        // Panel Body
        if (companyoverview.sanctions.length > 0) {
          for (i = 0; i < companyoverview.sanctions.length; i += 1) {
            columns = ['Detail', 'Value'];
            rows = [];

            const sanction = companyoverview.sanctions[i];

            rows.push(['Name', this.isEmptyMessage(sanction.name)]);
            rows.push(['Address', this.isEmptyMessage(sanction.address)]);
            rows.push(['Country', this.isEmptyMessage(sanction.country)]);
            rows.push(['Regime', this.isEmptyMessage(sanction.regime)]);
            rows.push(['Other Information', this.isEmptyMessage(sanction.other_information)]);
            rows.push(['Listed on', this.isEmptyMessage(this.formatDate(sanction.listed_date))]);
            rows.push([
              'Last Updated',
              this.isEmptyMessage(this.formatDate(sanction.last_updated)),
            ]);

            doc.autoTable(columns, rows, {
              margin: {
                left: this.pageStartX,
              },
              startY: this.cursorY,
              showHeader: 'everyPage',

              theme: this.tableTheme,
              styles: this.tableStyle,
              headerStyles: this.tableHeaderStyle,
              columnStyles: this.tableColumnStyle,
            });
            this.cursorY = doc.autoTable.previous.finalY + 30;
          }
          this.cursorY = doc.autoTable.previous.finalY + 30;
        }
      }

      /// ///////////////////////////////////////////////
      // New Page - Notes
      /// ////////////////////////////////////////////////

      if (includeNotes && companyoverview.company.notes.length > 0) {
        doc.addPage();
        this.setPageStart(this.pageLeftMargin, this.pageTopMargin);
        // page header
        doc.setTextColor(150, 150, 150);
        // company Name
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(companyoverview.company_name, this.cursorX, this.cursorY);
        // report date
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text(
          `Report Date: ${this.formatDate(companyoverview.created_at)}`,
          440,
          this.pageTopMargin - 30
        );
        this.moveCursorYRelative(40);

        doc.setTextColor(0, 0, 0);

        this.moveCursorYRelative(this.sectionTitleMarginTop);
        doc.setFontSize(this.sectionTitleFontSize);
        doc.setFontStyle(this.sectionTitleFontStyle);
        this.setTextDimensions(doc.getTextDimensions('Text'));
        doc.text('Notes', this.cursorX, this.cursorY);
        this.newLine(this.sectionTitleMarginBottom);

        this.moveCursorYRelative(this.subSectionTitleMarginTop);
        doc.setFontSize(10);
        doc.setFontStyle('normal');
        this.setTextDimensions(doc.getTextDimensions('Text'));
        for (j = 0; j < companyoverview.company.notes.length; j += 1) {
          const note = companyoverview.company.notes[j];
          const noteHeader =
            'On ' + this.formatDate(note.created_at, true) + ', ' + note.user.name + ' wrote';
          doc.setFontStyle('bold');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(noteHeader, this.cursorX, this.cursorY);
          this.moveCursorYRelative(20);
          doc.setFontStyle('normal');
          this.setTextDimensions(doc.getTextDimensions('Text'));
          doc.text(note.note, this.cursorX, this.cursorY);

          this.moveCursorYRelative(40);
        }
      }

      /// ////////////////////////////////////////////////
      // End of report content
      // Make report.
      /// ////////////////////////////////////////////////
      const filename = `${moment(companyoverview.created_at).format(
        'YYYY_MM_DD'
      )}_${companyoverview.company_name.split(' ').join('_')}`;
      // companyoverview.created_at+'_'+companyoverview.company_name
      // window.open(doc.output('bloburl'))
      doc.save(`${filename}.pdf`);

      resolve(); // Notify that the PDF generation is done
    }).catch((error) => {
      reject(error); // Handle errors properly
    });
    },
    setPageStart(x, y) {
      this.pageStartX = x;
      this.pageStartY = x;
      this.cursorX = x;
      this.cursorY = y;
    },
    setTextDimensions(dim) {
      this.textWidth = dim.w;
      this.textHeight = dim.h;
      return true;
    },
    newLine(additonalHeight = 0) {
      this.cursorY = this.cursorY + this.textHeight + additonalHeight;
    },
    newHalfLine(additonalHeight = 0) {
      this.cursorY = (this.cursorY + this.textHeight + additonalHeight) / 2;
    },
    moveCursorYRelative(moveYPx) {
      this.cursorY += moveYPx;
    },
  },
};